/**
 * Kaya Featured Products – Hover
 * Mobile carousel pagination dots: syncs active dot with scroll position
 * and lets users tap a dot to jump to a panel.
 */
(function () {
  'use strict';

  var MOBILE_BP = 750;

  function init(section) {
    var panels = section.querySelector('[data-kfph-panels]');
    var dotsWrap = section.querySelector('[data-kfph-dots]');
    if (!panels || !dotsWrap) return;

    var dots = Array.prototype.slice.call(
      dotsWrap.querySelectorAll('[data-kfph-dot]')
    );
    if (dots.length < 2) return;

    var slides = Array.prototype.slice.call(
      panels.querySelectorAll('.kfph__panel')
    );
    if (slides.length !== dots.length) return;

    var activeIndex = 0;
    var ticking = false;

    function setActive(idx) {
      if (idx === activeIndex) return;
      activeIndex = idx;
      for (var i = 0; i < dots.length; i++) {
        dots[i].setAttribute('aria-current', i === idx ? 'true' : 'false');
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var width = panels.clientWidth;
        if (width > 0) {
          var idx = Math.round(panels.scrollLeft / width);
          if (idx < 0) idx = 0;
          if (idx > slides.length - 1) idx = slides.length - 1;
          setActive(idx);
        }
        ticking = false;
      });
    }

    panels.addEventListener('scroll', onScroll, { passive: true });

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var idx = parseInt(dot.getAttribute('data-kfph-dot'), 10);
        if (isNaN(idx) || !slides[idx]) return;
        var target = slides[idx];
        panels.scrollTo({
          left: target.offsetLeft,
          behavior: 'smooth'
        });
      });
    });

    // Reset to first slide if viewport crosses the mobile boundary.
    var wasMobile = window.innerWidth < MOBILE_BP;
    window.addEventListener('resize', function () {
      var isMobile = window.innerWidth < MOBILE_BP;
      if (wasMobile !== isMobile) {
        wasMobile = isMobile;
        panels.scrollLeft = 0;
        setActive(0);
      }
    });
  }

  function initAll() {
    var sections = document.querySelectorAll('.kfph');
    for (var i = 0; i < sections.length; i++) init(sections[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init on Shopify theme editor section load.
  document.addEventListener('shopify:section:load', function (e) {
    if (e.target && e.target.classList && e.target.classList.contains('kaya-featured-products-hover')) {
      var sec = e.target.querySelector('.kfph');
      if (sec) init(sec);
    }
  });
})();
